import * as types from "./types";

const initialState = {
  title: "Dubito",
  drawMenuOpen: false,
  showSnack: false,
  snackTitle: ""
} as types.HeaderState;

export default function reducer(
  state = initialState,
  action: types.HeaderAction
): types.HeaderState {
  switch (action.type) {
    case types.CHANGE_TITLE:
      return {
        ...state,
        title: action.title,
        rightEnabled: false,
        showSearch: false
      };
    case types.CHANGE_DRAWER_MENU:
      return {
        ...state,
        drawMenuOpen: action.drawer
      };
    case types.CHANGE_HEADER_TITLE_AND_ACTION:
      return {
        ...state,
        rightAction: action.rightAction,
        rightText: action.rightText,
        rightEnabled: action.rightEnabled,
        title: action.title,
        onSearchText: action.onSearchText,
        showSearch: action.showSearch
      };
    case types.CHANGE_RIGHT_ACTION:
      return {
        ...state,
        rightAction: action.rightAction,
        rightText: action.rightText,
        rightEnabled: action.rightEnabled
      };
    case types.SHOW_SNACK_TOAST:
      return {
        ...state,
        snackTitle: action.title,
        showSnack: true,
        snackType: action.snackType
      };
    case types.HIDE_SNACK_TOAST:
      return {
        ...state,
        showSnack: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/header/reducer.ts